export enum ETypeOTP {
  Email = "email",
  Sms = "sms",
}

export enum EOtpScenarios {
  LOGIN_ADMIN = "login",
  CHANGE_ADMIN_PASSWORD = "change_password",
  CHANGE_ADMIN_EMAIL = "change_email",
  CHANGE_ADMIN_PHONE_NUMBER = "change_phone_number",
  USER_WITHDRAW = "user_withdraw",
  USER_DEPOSIT = "user_deposit",
  VERIFY_EMAIL = "verify_email",
  REGISTER_USER = "register_user",
  RESET_USER_PASSWORD = "reset_user_password",
  CHANGE_USER_EMAIL = "change_user_email",
  CHANGE_USER_PHONE_NUMBER = "change_user_phone_number",
  VERIFY_USER_PHONE_NUMBER = "verify_user_phone_number",
  LOGIN_BY_GOOGLE = "login_by_google",
}

export enum EPermissions {
  VIEW_MALL_DASHBOARD = "view_mall_dashboard_informations",
  EXPORT_MALL_DASHBOARD = "export_mall_report_data",
  VIEW_MALL_GENERAL = "view_mall_general_informations",
  MALL_GENERAL_ADMINISTRATOR = "mall_general_administrator",
  VIEW_MALL_ORDERS = "view_mall_orders_informations",
  MALL_ORDERS_ADMINISTRATOR = "mall_orders_administrator",
  VIEW_MALL_PRODUCT = "view_mall_products_informations",
  PRODUCT_MALL_ADMINISTRATOR = "mall_products_administrator",
}

export enum EKycStatus {
  REJECT = "reject",
  PENDING = "pending",
  VERIFIED = "verified",
  NOUPLOAD = "noupload",
}

export enum AssetTypeEnum {
  SINGLE_ASSET = "single_asset",
  COLLECTION_ASSET = "collection_asset",
  HYPER_ASSET = "hyper_asset",
}

export type TAssetType = AssetTypeEnum;

export enum HyperPoolNumberIndex {
  SPACE_ID = 1,
  START_BLOCK = 2,
  FUNRAI_GOAL = 3,
  FUNRAI_TOTAL_INVESTMENT = 4,
  FUNRAI_TOTAL_FEE = 5,
  INVEST_FEE_RATE = 6,
  WITHDGRAW_FEE_RATE = 7,
  TOTAL_RWA_REQUESTER = 8,
}

export enum SpaceId {
  MetaDAP = 1,
}

export enum IdType {
  ID_CARD = 1,
  PASSPORT = 2,
  DRIVER_LICENSE = 3,
  PHONE = 4,
  EMAIL = 5,
}

export enum SinglePoolNumberIndex {
  SPACE_ID = 1,
  START_BLOCK = 2,
  FUNRAI_GOAL = 3,
  FUNRAI_TOTAL_INVESTMENT = 4,
  FUNRAI_TOTAL_FEE = 5,
  INVEST_FEE_RATE = 6,
  WITHDGRAW_FEE_RATE = 7,
  ASSET_PRICE = 8,
}
